import { Color, rwd } from '@billy/design-system'
import styled from '@emotion/styled'

const SIDEBAR_WIDTH = 280
const MOBILE_MENU_HEIGHT = 88 // padding-top(20px) + menu button height(48px) + padding-bottom(20px)

export const DocumentsLayoutWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: ${SIDEBAR_WIDTH}px;
  border-right: 1px solid ${Color.Grey200};
  overflow: hidden;
`

export const MenuButtonSpacer = styled.div`
  flex-shrink: 0;
  height: ${MOBILE_MENU_HEIGHT}px;
  border-bottom: 1px solid ${Color.Grey200};

  ${rwd.greaterThan('xlarge')} {
    display: none;
  }
`

export const Content = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
`
